import { MotionConfig } from 'framer-motion';

import TopNav from '@/layouts/TopNav';
import { Footer } from '@/layouts/Footer';

import infuserImg from '@/assets/imgs/home/infuser-summary-all.png';
import qufaImg from '@/assets/imgs/home/qufa_structure.png';

import Hero from './n3/Hero';
import LogoWall from './n3/LogoWall';
import HistoryTimeline from './n3/HistoryTimeline';
import ProductShowcase from './n3/ProductShowcase';
import VerifierRows from './n3/VerifierRows';
import ProductDuo from './n3/ProductDuo';
import Closing from './n3/Closing';

/**
 * 공공데이터 메인 (/data) — N3 · Editorial Neon.
 * 풀페이지(100vh fit) 잔재 없이 자연 세로 스크롤 + 1240 컨테이너로 구성한다.
 * 다크 + 네온 톤은 AI 랜딩(.ai-home)과 통일된다.
 */
export default function HomeIndex() {
  return (
    <MotionConfig reducedMotion="user">
      <TopNav />
      <div className="public-data">
        <div className="pd-glows" aria-hidden>
          <span className="pd-glow pd-glow--cyan" />
          <span className="pd-glow pd-glow--purple" />
          <span className="pd-glow pd-glow--red" />
        </div>

        <Hero />
        <LogoWall />
        <HistoryTimeline />

        <ProductShowcase
          eyebrow="DATA INFUSER"
          title="Data Infuser"
          tagline="코드 없이 여는 오픈API의 새 시대"
          desc="GUI 기반 작성 환경으로 누구나 손쉽게 오픈API를 만들고, 다양한 데이터 소스를 연결합니다."
          bullets={['GUI 기반의 손쉬운 API 작성', '다양한 데이터 소스 지원', '컨테이너 방식의 손쉬운 설치']}
          image={infuserImg}
          imageAlt="Data Infuser 화면"
        />

        <ProductShowcase
          eyebrow="AI DATA VERIFIER"
          title="AI Data Verifier"
          tagline="데이터의 진실을 가장 빠르고 정확하게"
          desc="신뢰할 수 있는 출처를 기반으로 대량의 데이터를 실시간으로 검증하고 진위를 확인합니다."
          bullets={['신뢰할 수 있는 출처 기반 연계', 'Data Infuser 기반 실시간 처리', '대량 데이터 일괄 검증 지원']}
          visual={<VerifierRows />}
          reverse
        />

        <ProductShowcase
          eyebrow="QUFA STUDIO"
          title="QuFa Studio"
          tagline="데이터 품질·공정성 관리 통합 솔루션"
          desc="데이터 프로파일링부터 이상치 보정, AI 모델 기반 공정화까지 데이터 품질을 통합 관리합니다."
          bullets={['데이터 프로파일링·표준 용어 검증', '이상치 감지 및 보정', 'AI 모델 기반 데이터 공정화']}
          image={qufaImg}
          imageAlt="QuFa Studio 구조도"
        />

        <ProductDuo />
        <Closing />
      </div>
      <Footer />
    </MotionConfig>
  );
}
